type Props = {
  open: boolean;
  name: string;
  onChange: (v: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export function SaveModal({ open, name, onChange, onCancel, onConfirm }: Props) {
  if (!open) return null;
  return (
    <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl w-80 text-center animate-pop-in border-4 border-amber-300">
        <h3 className="font-bold mb-4">命名題庫</h3>
        <input
          type="text"
          value={name}
          onChange={(e) => onChange(e.target.value)}
          className="w-full p-2 border-2 rounded-lg mb-4 text-center"
          autoFocus
        />
        <div className="flex gap-2">
          <button onClick={onCancel} className="flex-1 bg-gray-200 py-2 rounded-lg">
            取消
          </button>
          <button onClick={onConfirm} className="flex-1 bg-amber-500 text-white py-2 rounded-lg">
            確定
          </button>
        </div>
      </div>
    </div>
  );
}
